import gql from 'graphql-tag';

// ポイント区分チェック及びプルダウン用ゴルフコード一覧取得
export const GET_POINT_USE_TYPE = gql`
    query ($golf_group_code: String!, $member_no: ID!) {
        getPointUseType(
            golf_group_code: $golf_group_code
            member_no: $member_no
        )
        {
            golf_name
            golf_code
        }
    },
`;

export const GET_MYPAGE_POINT_INFO = gql`
    query (
        $golf_group_code: String!,
        $member_no: ID!,
        $point_type: Int,
        $history_begin_row: Int,
        $history_limit_rows: Int,
        $display_flag: Int
    ) {
        getMypagePointInfo(
            golf_group_code: $golf_group_code
            member_no: $member_no
            point_type: $point_type
            history_begin_row: $history_begin_row
            history_limit_rows: $history_limit_rows
            display_flag: $display_flag
        )
        {
            pointUseType{
                golf_group_code
                golf_code
                golf_name
            }
            totalPoint{
                total_all
                total_normal
                total_limited_normal
                total_limited
                total_expected
                total_reserve
            }
            validDate{
                total_limited_normal
                total_limited
                expected_date
                play_date
            }
            pointList{
                id
                processing_date
                point_type
                point_type_display
                action
                point
                comment
            }
            count
        }
    },
`;

// ポイント数集計
export const GET_POINT_TOTAL = gql`
    query ($member_no: ID!, $golf_group_code: String!, $golf_code: String) {
        memberGetPointTotal(
            member_no: $member_no,
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
        ) {
            total_point{
                total_all
                total_normal
                total_limited_normal
                total_limited
                total_expected
                total_reserve
            }
            valid_date{
                total_limited_normal
                total_limited
                expected_date
                play_date
            }
        }
    }
`;

export const GET_RESERVEPAGE_POINT_TOTAL = gql`
    query ($member_no: ID!, $golf_group_code: String!, $golf_code: String,$target_date: String) {
        getReservePagePointTotal(
            member_no: $member_no,
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
            target_date: $target_date
        ) {
            total_point{
                total_all
                total_normal
                total_limited_normal
                total_limited
                total_expected
            }
            valid_date{
                total_limited_normal
                total_limited
                expected_date
            }
        }
    }
`;

export const GET_POINT_LIMITED_LIST = gql`
    query ($member_no: ID!, $golf_group_code: String!, $golf_code: String, $begin_row: Int, $limit_rows: Int) {
        getMemberLimitedPointList(
            member_no: $member_no,
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
            begin_row: $begin_row,
            limit_rows: $limit_rows
        )
        {
            MemberLimitedPointList {
                id
                valid_date
                action
                point
                comment
                point_type
                point_type_display
            }
            count
        }
    }
`;

export const GET_MYPAGE_TOP_INFO = gql`
    query ($golf_group_code: String!, $golf_code: String, $begin_row: Int, $limit_rows: Int) {
        GetMypageTopInfo(
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
            begin_row: $begin_row,
            limit_rows: $limit_rows
        )
        {
            memberStatusType
            memberCodeSetting
            displayMemberCodeSetting
            chatboxSetting
            ReserveInfo{
                ReserveList {
                    play_date
                    golf_name
                    play_start
                }
            }
            MessageInfo{
                time
                reserve_no
                play_date
            }
            memberRank
            pointUseType{
                golf_group_code,
                golf_code,
                golf_name
            }
            totalPoint{
                total_all
                total_normal
                total_limited_normal
                total_limited
                total_expected
                total_reserve
            }
            validDate{
                total_limited_normal
                total_limited
                expected_date
                play_date
            }
            MemberLimitedPointList {
                id
                valid_date
                action
                point
                comment
                point_type
                point_type_display
            }
            count
        }
    }
`;

// ゴルフ場毎のポイント数集計
export const GET_GOLF_COURSE_POINT_TOTAL = gql`
    query ($member_no: ID!, $golf_group_code: String!, $golf_code: String, $begin_row: Int, $limit_rows: Int) {
        getGolfCoursePointTotal(
            member_no: $member_no,
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
            begin_row: $begin_row,
            limit_rows: $limit_rows
        ) {
            total_point{
                total_all
                total_normal
                total_limited_normal
                total_limited
                total_expected
                total_reserve
            }
            valid_date{
                total_limited_normal
                total_limited
                expected_date
                play_date
            }
            MemberLimitedPointList {
                id
                valid_date
                action
                point
                comment
                point_type
                point_type_display
            }
            count
        }
    }
`;

export const GET_FOOTER_MENU = gql`
    query ($member_no: ID, $line_login_flag: Boolean) {
        GetFooterMenu(
            member_no: $member_no
            line_login_flag: $line_login_flag
        ) {
            footerMenuList {
                menu_id
                title
                footer_title
                to
                name
                icon_class
                text_flag
            }
        }
    }`
